window.loadedScripts = 1;
import '@core/polyfills';
import 'cookieconsent';

import Vue from 'vue'
import Http from 'axios'
import Store from '@default/store'
import Router from '@default/router'

import '@default/directives/contentParser.js'
import '@default/directives/imageLazyLoad.js'
import '@default/directives/focusArea.js'
import '@default/directives/eventTracking.js'

import AppGlobals from '@default/plugins/AppGlobals.js'

import App from '#app#/components/App.vue'
import Link from '#app#/components/common/Link.vue'
import SvgHelper from '#app#/components/util/svgHelper.vue'

Vue.use(AppGlobals);
Vue.component('link-component', Link);
Vue.component('svg-helper', SvgHelper);

Http.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
Http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Remove static javascript for language and frontend user initializing
const jsInitEl = document.getElementById('jsInit');
jsInitEl.parentNode.removeChild(jsInitEl);

new Vue({
    el: '#app',
    store: Store,
    router: Router,
    render: h => h(App)
})


// WEBPACK FOOTER //
// ../default-js/js/app.js